import axios from 'axios'
import { PAYMENT_ENDPOINT } from '../../endpoints'

export async function getUrlAdministrator(firstname, lastname, email) {

    const url = `${PAYMENT_ENDPOINT}/dashboard?firstname=${firstname}&lastname=${lastname}&email=${email}`

    const response = await axios.get(url)

    return response.data
}